import type { FormeTable } from '../../lib/reservationsPlanApi';

/** Formes de tables (libellés et formes proposées dans les formats de l'établissement). */
export const LIBELLE_FORME: Record<FormeTable, string> = { carre: 'carrée', rond: 'ronde', rectangle: 'rectangulaire', ovale: 'ovale', plateau: 'plateau', banquette: 'banquette' };
export const FORMES_PROPOSEES: FormeTable[] = ['rond', 'carre', 'rectangle', 'ovale'];
